export const USER_DATA = "model/user";
export const LOADER_CURRENCY_LIST = "loader/currencyList";
